import { useSaveLegalRepresentativeDraftMutation } from '../../../redux/api/questionnaire/questionnaire-api';
import useDraft from '../common/draft/useDraft';

export const useLegalRepresentativeDraft = () => {
  return useDraft(
    questionnaire => questionnaire.legalRepresentativeForm,
    useSaveLegalRepresentativeDraftMutation
  );
};
